import { useContext, useState, useEffect, useRef } from "react";
import Table from "react-bootstrap/Table";
import { Form, Dropdown, Modal, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { HiMagnifyingGlass } from "react-icons/hi2";
import InputGroup from "react-bootstrap/InputGroup";
import { Ucontext } from "../context/Ucontext";
import Loading from "../components/loader/Loading";
import { getAnalysisTransactions } from "../context/functions/AdminFunction";
import moment from "moment";
import { haveValue } from "../utils/common";
import Pagination from "../components/Pagination";

const AnalysisReport = () => {
  const { adminDispatch, adminState } = useContext(Ucontext);
  const queryParameters = new URLSearchParams(window.location.search);

  const { totalAnalysisTransactions } = adminState;
  const [loading, setLoading] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [currentPage, setcurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [detailsShow, setDetailsShow] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const abortControllerRef = useRef(null);

  const [filter, setFilter] = useState({
    status: "",
    analysis_type: "",
  });

  useEffect(() => {
    const controller = new AbortController();
    abortControllerRef.current = controller;

    loadAnalysisTransactions(currentPage, searchVal, filter, controller.signal);

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [currentPage, searchVal, filter]);

  const loadAnalysisTransactions = async (currentPage, searchVal, filter, signal = null) => {
    setLoading(true);
    const { status, analysis_type } = filter;

    let response = await getAnalysisTransactions(
      currentPage,
      searchVal,
      status,
      analysis_type,
      signal
    );

    if (response?.status === "canceled") {
      return;
    }

    if (response.success == true) {
      adminDispatch({
        type: "ANALYSIS_TRANSACTIONS_LOADED",
        payload: response?.data,
      });
      setTotalPages(response?.totalPages);
    }
    setLoading(false);
  };

  let interval;
  const handleSearch = (e) => {
    clearTimeout(interval);
    interval = setTimeout(() => {
      setSearchVal(e.target.value);
      setcurrentPage(1);
    }, 500);
  };

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const handlePageClick = (event) => {
    setcurrentPage(event.selected + 1);
  };

  const handleClickFilter = (e) => {
    setFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setcurrentPage(1);
  };

  const viewPropDetail = (value) => {
    setUserDetails(value);
    setDetailsShow(true);
  };

  return (
    <>
      <div className="data-main">
        <div className="data-header-box">
          <div className="header_table d-flex justify-content-between align-items-center">
            <h1>Forensic analysis / Document analysis Ledger</h1>
          </div>

          <div className="d-flex justify-content-around lanloard-admin-filter">
            <div className="searchbar_table landloard-filter-box">
              <div>
                <h5>Status</h5>
                <Form.Select
                  onChange={handleClickFilter}
                  name="status"
                  id="status"
                >
                  <option value="">All</option>
                  <option value="completed">Completed</option>
                  <option value="processing">Processing</option>
                  <option value="failed">Failed</option>
                </Form.Select>
              </div>
              <div>
                <h5>Type</h5>
                <Form.Select
                  onChange={handleClickFilter}
                  name="analysis_type"
                  id="analysis_type"
                >
                  <option value="">All</option>
                  <option value="forensic_analysis">Forensic Analysis</option>
                  <option value="document_analysis">Document Analysis</option>
                </Form.Select>
              </div>

              <div>
                <InputGroup className="input_table_header ">
                  <InputGroup.Text id="basic-addon1">
                    <HiMagnifyingGlass />
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Search"
                    aria-label="Search"
                    aria-describedby="basic-addon1"
                    // value={searchVal}
                    defaultValue={
                      haveValue(queryParameters.get("email"))
                        ? queryParameters.get("email")
                        : ""
                    }
                    onChange={handleSearch}
                  />
                </InputGroup>
              </div>
            </div>
          </div>
        </div>

        <Table responsive hover>
          <thead className="landloar-tabel-head">
            <tr>
              <th>Tenant Name</th>
              <th>Tenant Email</th>
              <th>Analysis Type</th>
              <th>Retries</th>
              <th>Status</th>
              <th>Time Taken</th>
              <th>Started At</th>
              <th>Ended At</th>
              {/* <th></th> */}
            </tr>
          </thead>
          <tbody className="landloar-tabel-head">
            {loading ? <Loading /> : null}
            {totalAnalysisTransactions &&
              totalAnalysisTransactions.map((data, index) => (
                <tr key={data?._id}>
                  <td className="text-capitalize">
                    {data?.tenant?.fname + " " + data?.tenant?.lname ?? "-"}
                  </td>
                  <td>{data?.tenant?.email ?? "-"}</td>
                  <td>{data?.analysis_type ?? "-"}</td>
                  <td>{data?.retries ?? "-"}</td>
                  <td className="text-capitalize">{data?.status ?? "-"}</td>
                  <td>
                    {data.ended_at
                      ? (() => {
                          const diff = moment(data.ended_at).diff(
                            moment(data.created_at)
                          );
                          const duration = moment.duration(diff);
                          const minutes = duration.minutes();
                          const seconds = duration.seconds();
                          return `${minutes}m ${seconds}s`;
                        })()
                      : "-"}
                  </td>
                  <td>
                    {moment(data.created_at).format("DD MMMM YYYY, HH:mm:ss")}
                  </td>
                  <td>
                    {data.ended_at
                      ? moment(data.ended_at).format("DD MMMM YYYY, HH:mm:ss")
                      : "-"}
                  </td>
                  {/* <td>
                    <a onClick={() => viewPropDetail(data?.tenant)}>
                      View Details
                    </a>
                  </td> */}
                </tr>
              ))}
            {totalAnalysisTransactions?.length === 0 && (
              <tr>
                <td colSpan={10} className="">
                  No Data Found!
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <Pagination
          currentPage={currentPage - 1}
          totalPages={totalPages}
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          marginPagesDisplayed={2}
        />

        <Modal
          show={detailsShow}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header
            onClick={() => {
              setDetailsShow(false);
            }}
            closeButton
          >
            <Modal.Title id="contained-modal-title-vcenter">
              Tenant Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h5 className="modal_h5 d-flex align-items-center">Dummy Data</h5>

            <div className="property_modal">
              <Row>
                <p>
                  Tenant Name.{" "}
                  <span>
                    {userDetails?.fname} {userDetails?.lname}
                  </span>
                </p>
              </Row>
              <Row>
                <p>
                  Tenant Id. <span>{userDetails?._id}</span>
                </p>
              </Row>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default AnalysisReport;
